import React from 'react'
import styles from './IconTextFile.module.scss'

export default function IconTextFile() {
    return <div className={styles.root} />
}
